export default __webpack_public_path__ + "static/NEST-7b22d352ae96d971427f605afb26bdb0.svg";